import colors from '~/colors';
import { Prefs, setPref } from '~/common/prefs';
import type { MapStyle } from '~/common/types';
import rootStore from '~/store';

export function onRootBasemapChange(style: MapStyle) {
  setPref(Prefs.LAST_USED_BASEMAP, JSON.stringify(style));
  rootStore.preferredBasemap = style;
}

/**
 * @deprecated Bypassed in favor of the static PROJECT_AREA_* constants in ~/colors; not called anywhere.
 * Retained for reference — revisit if per-basemap (conditional) project-line contrast is reintroduced.
 * returns [primaryColor, selectedColor]
 */
export function getProjectLineColor(mapStyleName?: string): [string, string] {
  const { white, brand, brandDark, primaryDark } = colors;
  if (
    mapStyleName === 'Mapbox Satellite Streets' ||
    mapStyleName === 'Mapbox Satellite' ||
    mapStyleName === 'Satellite (Google)' ||
    mapStyleName === 'Satellite (ESRI)'
  ) {
    return [white, brand];
  } else if (mapStyleName === 'Mapbox Dark' || mapStyleName === 'CivilGrid Dark') {
    return [brand, white];
  } else if (mapStyleName === 'Mapbox Light' || mapStyleName === 'CivilGrid Light') {
    return [brandDark, primaryDark];
  } else if (mapStyleName === 'Mapbox Outdoors' || mapStyleName === 'Mapbox Streets') {
    return [primaryDark, brand];
  } else if (mapStyleName === 'White') {
    return [primaryDark, brand];
  }

  return [white, brand];
}
